module.exports = __webpack_public_path__ + "static/media/2022-may-image-1.6b82b68d.png";